export default "__VITE_ASSET__754c70e5__"